import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PAYMENT_STATUS } from '../../../constants/paymentStatus';

/**
 * Reusable Payment Status Chip Component
 * @param {string} paymentStatus - Payment status (Paid, Not Paid, Partial Paid)
 * @param {object} sx - Additional styles
 */
const PaymentStatusChip = ({ paymentStatus, sx = {} }) => {
  const { t } = useTranslation();

  const getPaymentStatusConfig = (status) => {
    switch (status) {
      case PAYMENT_STATUS.PAID:
        return {
          label: t('paid'),
          bgcolor: '#d4edda',
          textColor: '#155724',
        };
      case PAYMENT_STATUS.NOT_PAID:
        return {
          label: t('not_paid'),
          bgcolor: '#f8d7da',
          textColor: '#721c24',
        };
      case PAYMENT_STATUS.PARTIAL_PAID:
        return {
          label: t('partial_paid'),
          bgcolor: '#fff3cd',
          textColor: '#856404',
        };
      default:
        return {
          label: t('unknown'),
          bgcolor: '#e0e0e0',
          textColor: '#616161',
        };
    }
  };

  const config = getPaymentStatusConfig(paymentStatus);

  return (
    <Chip
      label={config.label}
      size="small"
      sx={{
        bgcolor: config.bgcolor,
        color: config.textColor,
        fontWeight: 600,
        fontSize: '0.75rem',
        textTransform: 'uppercase',
        ...sx,
      }}
    />
  );
};

export default PaymentStatusChip;
